import { IntervalReportApi } from '@/api/IntervalReportApi'
import { IntervalReportSearchResults } from './IntervalReportSearchResults'
import { IntervalMailSendingStatus, Period, Interval } from './Constants'

export class IntervalReportRepository {
  static async search(keyword, advertiserId, pageNo) {
    try {
      const pageSize = 20
      const res = await IntervalReportApi.search(
        keyword,
        advertiserId,
        pageNo,
        pageSize,
      )
      return IntervalReportSearchResults.assign(res, pageSize)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async get(id) {
    try {
      const res = await IntervalReportApi.get(id)
      return res.item
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async getCsvReport(report) {
    try {
      const insertionOrderIds = report.query.insertionOrderAddedList
        ? report.query.insertionOrderAddedList.map(io => io.id)
        : report.query.insertionOrderIds
      return await IntervalReportApi.getReport({
        advertiserId: report.advertiserId,
        insertionOrderIds: insertionOrderIds,
        dimension: report.query.dimension,
        interval: report.query.interval,
        period: this.makePeriod(report.query),
        isIncludeBudget: this.isIncludeBudget(report.query),
        isIncludeCreative: report.query.isIncludeCreative,
        format: 'csv',
      })
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static makePeriod(query) {
    return query.period === Period.SELECT
      ? { startDate: query.startDate, endDate: query.endDate }
      : query.period
  }

  static isIncludeBudget(query) {
    return query.interval === Interval.INSERTION_ORDER_BUDGET
      ? true
      : query.isIncludeBudget
  }

  static async create(form) {
    await IntervalReportApi.create(this.makeIntervalReportRequest(form))
  }

  static async update(form) {
    await IntervalReportApi.update(this.makeIntervalReportRequest(form))
  }

  static makeIntervalReportRequest(form) {
    const query = form.query
    const notification = form.notification
    return {
      id: form.id,
      advertiserId: form.advertiserId,
      name: form.name,
      description: form.description,
      status: form.status,
      query: {
        insertionOrderIds: form.query.insertionOrderAddedList.map(
          item => item.id,
        ),
        dimension: query.dimension,
        interval: query.interval,
        period: this.makePeriod(query),
        isIncludeBudget: this.isIncludeBudget(query),
        isIncludeCreative: query.isIncludeCreative,
      },
      notification: {
        sendInterval: notification.sendInterval,
        emails: notification.emails.filter(mail => mail),
        closingDate: notification.closingDate,
        encode: notification.encode,
      },
    }
  }

  static async updateStatus(id, isActive) {
    const status = isActive
      ? IntervalMailSendingStatus.INACTIVE
      : IntervalMailSendingStatus.ACTIVE
    try {
      const res = await IntervalReportApi.updateStatus(id, status)
      return res.item.status
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async remove(id) {
    try {
      await IntervalReportApi.remove(id)
    } catch (e) {
      console.error(e)
      throw e
    }
  }
}
